/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './multiselect-companies.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../../app/modules/employee/pages/companies/multiselect-companies/multiselect-companies.component';
import * as i3 from '../../../../../../../$$_gendir/node_modules/primeng/components/multiselect/multiselect.ngfactory';
import * as i4 from 'primeng/components/dom/domhandler';
import * as i5 from 'primeng/components/utils/objectutils';
import * as i6 from 'primeng/components/multiselect/multiselect';
import * as i7 from '@angular/forms';
import * as i8 from '../../../../../../../app/modules/employee/service/company/company.service';
const styles_MultiSelectCompaniesComponent:any[] = [i0.styles];
export const RenderType_MultiSelectCompaniesComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_MultiSelectCompaniesComponent,data:{}});
export function View_MultiSelectCompaniesComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{textarea:0}),(_l()(),i1.ɵeld(1,0,(null as any),
      (null as any),8,'p-multiSelect',[['appendTo','body'],['defaultLabel','Elija'],
          ['optionLabel','label']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'onChange']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.MultiSelectCompaniesComponent = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.companiesSelected = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('onChange' === en)) {
          const pd_1:any = ((<any>_co.change($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_MultiSelect_0,i3.RenderType_MultiSelect)),i1.ɵprd(512,(null as any),
      i4.DomHandler,i4.DomHandler,([] as any[])),i1.ɵprd(512,(null as any),i5.ObjectUtils,
      i5.ObjectUtils,([] as any[])),i1.ɵdid(4,13877248,[[1,4],['input',4]],1,i6.MultiSelect,
      [i1.ElementRef,i4.DomHandler,i1.Renderer2,i5.ObjectUtils,i1.ChangeDetectorRef],
      {defaultLabel:[0,'defaultLabel'],appendTo:[1,'appendTo'],optionLabel:[2,'optionLabel'],
          options:[3,'options']},{onChange:'onChange'}),i1.ɵqud(603979776,2,{templates:1}),
      i1.ɵprd(1024,(null as any),i7.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i6.MultiSelect]),i1.ɵdid(7,671744,(null as any),0,i7.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i7.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i7.NgControl,
          (null as any),[i7.NgModel]),i1.ɵdid(9,16384,(null as any),0,i7.NgControlStatus,
          [i7.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i2.MultiSelectCompaniesComponent = _v.component;
    const currVal_7:any = 'Elija';
    const currVal_8:any = 'body';
    const currVal_9:any = 'label';
    const currVal_10:any = _co.companiesOptions;
    _ck(_v,4,0,currVal_7,currVal_8,currVal_9,currVal_10);
    const currVal_11:any = _co.companiesSelected;
    _ck(_v,7,0,currVal_11);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,9).ngClassUntouched;
    const currVal_1:any = i1.ɵnov(_v,9).ngClassTouched;
    const currVal_2:any = i1.ɵnov(_v,9).ngClassPristine;
    const currVal_3:any = i1.ɵnov(_v,9).ngClassDirty;
    const currVal_4:any = i1.ɵnov(_v,9).ngClassValid;
    const currVal_5:any = i1.ɵnov(_v,9).ngClassInvalid;
    const currVal_6:any = i1.ɵnov(_v,9).ngClassPending;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
export function View_MultiSelectCompaniesComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-multiselect-companies',
      ([] as any[]),(null as any),(null as any),(null as any),View_MultiSelectCompaniesComponent_0,
      RenderType_MultiSelectCompaniesComponent)),i1.ɵprd(5120,(null as any),i7.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i2.MultiSelectCompaniesComponent]),i1.ɵdid(2,49152,(null as any),0,i2.MultiSelectCompaniesComponent,
      [i1.Renderer2,i8.CompanyService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const MultiSelectCompaniesComponentNgFactory:i1.ComponentFactory<i2.MultiSelectCompaniesComponent> = i1.ɵccf('app-multiselect-companies',
    i2.MultiSelectCompaniesComponent,View_MultiSelectCompaniesComponent_Host_0,{companiesId:'companiesId'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvY29tcGFuaWVzL211bHRpc2VsZWN0LWNvbXBhbmllcy9tdWx0aXNlbGVjdC1jb21wYW5pZXMuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2NvbXBhbmllcy9tdWx0aXNlbGVjdC1jb21wYW5pZXMvbXVsdGlzZWxlY3QtY29tcGFuaWVzLmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L2luZXRwdWIvd3d3cm9vdC9rYWl6ZW4tbmcvc3JjL2FwcC9tb2R1bGVzL2VtcGxveWVlL3BhZ2VzL2NvbXBhbmllcy9tdWx0aXNlbGVjdC1jb21wYW5pZXMvbXVsdGlzZWxlY3QtY29tcGFuaWVzLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvY29tcGFuaWVzL211bHRpc2VsZWN0LWNvbXBhbmllcy9tdWx0aXNlbGVjdC1jb21wYW5pZXMuY29tcG9uZW50LnRzLk11bHRpU2VsZWN0Q29tcGFuaWVzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHAtbXVsdGlTZWxlY3QgI2lucHV0IFtvcHRpb25zXT1cImNvbXBhbmllc09wdGlvbnNcIiBvcHRpb25MYWJlbD1cImxhYmVsXCIgWyhuZ01vZGVsKV09XCJjb21wYW5pZXNTZWxlY3RlZFwiIGRlZmF1bHRMYWJlbD1cIkVsaWphXCIgKG9uQ2hhbmdlKT1cImNoYW5nZSgkZXZlbnQpXCIgYXBwZW5kVG89XCJib2R5XCI+PC9wLW11bHRpU2VsZWN0PlxyXG4iLCI8YXBwLW11bHRpc2VsZWN0LWNvbXBhbmllcz48L2FwcC1tdWx0aXNlbGVjdC1jb21wYW5pZXM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3NEQ0FBO01BQUE7VUFBQTtVQUFBO1VBQUE7Y0FBQTtNQUFBO1FBQUE7UUFBQTtRQUF1RTtVQUFBO1VBQUE7UUFBQTtRQUFxRDtVQUFBO1VBQUE7UUFBQTtRQUE1SDtNQUFBO2tDQUFBO3FCQUFBLHNCQUFBO01BQUE7TUFBQTtVQUFBO2FBQUE7UUFBQTtNQUFBLDJCQUFBO1VBQUE7VUFBQSwyQ0FBQTtVQUFBLG1DQUFBO1VBQUEsNENBQXdMO1VBQUE7O0lBQWpGO0lBQWlEO0lBQXJHO0lBQTdCO0lBQXRCLFdBQXVHLFVBQWlELFVBQXJHLFVBQTdCLFVBQXRCO0lBQXVFO0lBQXZFLFdBQXVFLFVBQXZFOztJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUE7SUFBQTtJQUFBO0lBQUEsV0FBQSxxRUFBQTs7OztvQkNBQTtNQUFBOzhDQUFBO01BQUE7UUFBQTtNQUFBLDZDQUFBO01BQUE7Ozs7OyJ9



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/companies/multiselect-companies/multiselect-companies.component.ngfactory.ts